/* eslint-disable */
import React, { useState, useEffect, useRef, Fragment } from "react";
import {
    Card,
    Layout,
    Row,
    Col,
    Button,
    Input,
    message,
    Modal,
    Space,
    TimePicker,
    DatePicker,
    Form,
    Table,
    Select, Badge,
    Divider
} from "antd";
import {
    EditOutlined,
    MoreOutlined,
    ImportOutlined,
    DownloadOutlined,
    PrinterOutlined,
    QrcodeOutlined,
    CheckCircleOutlined,
    EyeFilled,
  } from "@ant-design/icons";
import { Redirect } from "react-router-dom";
import Axios from "axios";
import moment from "moment";
import { url } from "../../config/global";
import { BarcodeOutlined } from "@ant-design/icons";
const { Search } = Input;
const { Content } = Layout;

const layout = {
    labelCol: {
        xs: 24,
        lg: 24,
        md: 24,
    },
    wrapperCol: {
        xs: 24,
        lg: 24,
        md: 24,
    },
};

function MasterStockExt(props) {
    const [selectedRowKeysData, setSelectedRowKeysData] = useState([]);
    const [selectedRowsData, setSelectedRowsData] = useState([]);
    const [beforePaintList, setbeforePaintList] = useState([]);
    const [page, setPage] = useState(1);
    const [dnExtProcess, setdnExtProcess] = useState([]);
    const [loading, setloading] = useState(false);
    const [loadingPrint, setloadingPrint] = useState(false);
    const [loadingDetail, setLoadingDetail] = useState(false);
    const [pageSize, setPagesize] = useState(50);

    const [failedData, setfailedData] = useState([]);
    const [oneTimeGet, setOneTimeGet] = useState(false);

    const [sort, setSort] = useState({
        sort: "item_code",
        order: "ascend",
    });
    const [data, setData] = useState({
        ref_dn: null,
        lot_prod: null,
        dn_outgoing: null,
        item_after: null,
        kanban_no: [],
        scan_outgoing_id: null,
        qty: 0,
    });
    const [rowDetails, setRowDetails] = useState([]);
    const [keyword, setKeyword] = useState(null);
    const [orderDate, setOrderDate] = useState(null);
    const [dataStock, setStockData] = useState([]);
    const [selectedId, setSelectedId] = useState("");
    const [dataDetail, setDataDetail] = useState([]);
    const [totalHead, setTotalHead] = useState(0);
    const [totalDetail, setTotalDetail] = useState(0);
    const [descInput, setDescInput] = useState([]);
    const [afterItemInput, setafterItemInput] = useState(null);
    const [pageDetail, setPageDetail] = useState(1);
    const [pageSizeDetail, setPagesizeDetail] = useState(10);
    const [perPageDetail, setPerPageDetail] = useState(10);
    const [refDNInput, setrefDNInput] = useState(null);
    const [refDNInputID, setrefDNInputID] = useState(null);
    const [failedModal, setFailedModal] = useState(false);
    const [submitTime, setsubmitTime] = useState(null);
    const [buttonAccess, setButtonAccess] = useState(null);
    const [generate, setGenerate] = useState([]);
    const [sortDetail, setSortDetail] = useState({
        sort: "updated_at",
        order: "descend",
      });
    const permissions =
        sessionStorage.getItem("permissions") &&
        JSON.parse(sessionStorage.getItem("permissions"));
    useEffect(() => {
        const pathname = window.location.pathname.split("/");
        const currentUrl = pathname[1];
        if (permissions) {
            const findPermission = permissions.find(
                (permission) => permission.url === currentUrl
            );
    
            const findChildPermission = permissions
                .map((child) => {
                    return child.children.find(
                        (grandChild) => grandChild.url === currentUrl
                    );
                })
                .filter((grandChild) => grandChild)[0];
    
            if (findChildPermission && findChildPermission.children) {
                if (findChildPermission.children) {
                    const findButtonAccessChildren = findChildPermission.children
                        .filter((x) => x !== null)
                        .filter((x) => x.permission_type === "button");
                    if (findButtonAccessChildren) {
                        setButtonAccess(findButtonAccessChildren.filter((x) => x !== null));
                    }
                }
            }
    
            if (findPermission && findPermission.children) {
                const findButtonAccess = findPermission.children.filter(
                    (x) => x.permission_type === "button"
                );
                if (findButtonAccess) {
                    setButtonAccess(findButtonAccess);
                }
            }
        }
    },[])
    useEffect(() => {
        getStocks();
    }, [keyword, page, sort,orderDate]);
    
      const handleTableChange = (pagination, filters, sorter) => {
        setPagesize(pagination.pageSize);
        setPage(pagination.current);
        setSort({
          sort: sorter.field,
          order: sorter.order,
        });
      };
   
     
      
    
    const getStocks = () => {
        setloading(true);
        Axios.get(`${url}/master-stock-internal/get-data`, {
          params: {
           keyword:keyword,
           columns: [
            "item_number",
            "used_to_code",
            "tanggal",
            "keterangan",
          ],
          perpage:pageSize,
          page:page,
          filter_date:orderDate,
          },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }).then((res) => {
          setStockData(res.data.data);
          setTotalHead(res.data.total);
          setloading(false);
        }) .catch((err) => {
            setloading(false);

          if (err.response) {
            setData({
              ...data,
              kanban_number: "",
            });
            Modal.error({
              title: "Failed!",
              content: err.response.data.message,
            });
            
            if (err.response.status == 401) {
              sessionStorage.removeItem("token");
            }
          }
        });
      };

    const closeModal = () => {
        setFailedModal(false);
    };
    
      const handleDatepicker = (value) => {
        if (value != null) {
          var date = moment(value).format("YYYY-MM-DD");
          
          setOrderDate(date);
        }
      };
      const handleSearch = (value) => {
        if (value != null) {
        
        
          setKeyword(value);
        }
      };
     
    const printAll = () => {
        setloading(true);
        Axios.post(
          `${url}/dn-ext-process/print-all`,
          {
            data: generate,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
          .then((res) => {
            setloading(false);
            Modal.success({
              title: "Success!",
              content: res.data.message,
            });
            getStocks();
            window.open(res.data.filename);
           
          })
          .catch((err) => {
            // console.log(err.response.data);
                if (err.response) {
                 
                  Modal.error({
                    title: "Failed!",
                    content: err.response.data.message,
                  });
                  // message.error(err.response.data.message);
                  if (err.response.status === 422) {
                    setError(err.response.data.errors);
                  }
                  if (err.response.status === 401) {
                    sessionStorage.removeItem("token");
                  }
                }
                setloading(false);
          }
          );
    };


    const columns = [
        {
          title: "Tipe",
          dataIndex: "type",
          sorter: true,
        },
        {
          title: "Terakhir Update",
          dataIndex: "tanggal",
          sorter: true,
        },
        {
            title: "Item Number",
            dataIndex: "item_number",
            sorter: true,
        },
       
        {
            title: "Model",
            dataIndex: "model",
            sorter: true,
        },
        {
            title: "Std Pack",
            dataIndex: "std_pack",
            sorter: true,
            // render: (index, record) => {
            //     return record.supplier_name+" (" + record.supplier_code + ") ";
            // }
        },
      
        {
            title: "Current Stock",
            dataIndex: "qty_kanban",
            sorter: true,
        },
        {
            title: "Storage",
            dataIndex: "storage",
            sorter: true,
        },
      
        {
            title: "Action",
            dataIndex: "action",
            sorter: true,
            
            render: (index, record) => {
                return (<>
                
                  
                <Button
                        // loading={loading}
                        type="primary"
                    >
                        <EyeFilled />
                       Detail
                    </Button>
                <Button
                        // loading={loading}
          
                        color="#ffc53d"
                    >
                        <EditOutlined />
                       Adjust
                    </Button>
                </>)
            }
        },
       
       
    ];

    return (
        <Fragment>

            <Row>
                <Col xs={24}>
                    <Card
                        type="inner"
                        title=" Master Stock"
                        bodyStyle={{ padding: "0" }}
                        extra={moment(new Date()).format("DD MMMM YYYY")}
                    ></Card>
                </Col>
            </Row>
            <Content className="content">
                <Row>
                    <Col xs={24}>
                        <Card className="body-data">
                            <Form {...layout} layout="vertical" >
                                <Row>
                                    <Col  xs={24} md={12} lg={16}>
                                       
                                                <Button
                                                    loading={loadingPrint}
                                                    onClick={printAll}
                                                    type="primary"
                                                >
                                                    <PrinterOutlined />
                                                    Print All
                                                </Button>
                                         
                                    </Col>
                                    
                                    <Col xs={24} md={12} lg={8} className="align-right">
                                        <DatePicker
                                        placeholder="Delivery Date"
                                        onChange={(value) => handleDatepicker(value)}
                                        presetsWidth={60}
                                        />
                                        <Search
                                        placeholder="Search ..."
                                        onSearch={(value) => handleSearch(value)}
                                        />
                                    </Col>
                  </Row>
                  <Divider />
                                <Row>
                                    <Col xs={24} md={24} lg={24}>
                                        <Table
                                            scroll={{ x: 1400 }}
                                            columns={columns}
                                           
                                            size="small"
                                            dataSource={dataStock}
                                            rowKey={(data) => data._id}
                                            onChange={handleTableChange}
                                            pagination={{
                                                pageSize: pageSize,
                                                total: totalHead,
                                                showSizeChanger: false,
                                            }}
                                            loading={loading}
                                            />
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </Content>
        </Fragment>
    );
}

export default MasterStockExt;
